var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2.465.1"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/_catalog";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
import { APP_NAME } from './src/libs/constants';

const { publicRuntimeConfig } = getConfig();

if (publicRuntimeConfig.sentryEnable) {
  console.log('Loading sentry client config');

  Sentry.init({
    dsn: publicRuntimeConfig.sentryDsn || 'https://db1b225d016a4e52bbf42d3ababc63e2@o263529.ingest.sentry.io/5582611',
    environment: publicRuntimeConfig.envName,
    release: ['local', 'testing'].includes(publicRuntimeConfig.envName)
      ? publicRuntimeConfig.envName
      : publicRuntimeConfig.version,
    tunnel: `/_${APP_NAME}/api/sentry-tunnel`,
    // This should be a float/double between 0.0 and 1.0 (inclusive) and represents
    // the percentage chance that any given transaction will be sent to Sentry
    // https://develop.sentry.dev/sdk/performance/
    tracesSampleRate: publicRuntimeConfig.envName === 'white' ? 0.002 : 0,
    allowUrls: publicRuntimeConfig.i18n.domains
      .map(config => config.domain)
      .filter(domain => !domain.endsWith('.test')),
  });
}
